module.exports = __webpack_public_path__ + "img/Selo1.1d61892b.svg";